import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { alpha } from '@mui/material/styles';

import {
  ACCESS_TIERS,
  getAccessPolicy,
} from '../../configs/accessPolicies';

export const ACCESS_TIER_LABELS = {
  [ACCESS_TIERS.CORE]: 'CORE',
  [ACCESS_TIERS.RESEARCH]: 'RESEARCH',
};

function AccessTierBadge({
  accessPolicyId,
  requiredTier,
  locked = false,
  compact = false,
  disableTooltip = false,
  sx,
}) {
  const resolvedTier = requiredTier || (accessPolicyId
    ? getAccessPolicy(accessPolicyId).requiredTier
    : null);
  const label = ACCESS_TIER_LABELS[resolvedTier];

  if (!label) return null;

  const tooltip = resolvedTier === ACCESS_TIERS.RESEARCH
    ? 'Included with SoftwareIQ Research Suite'
    : 'Included with SoftwareIQ Core';
  const icon = locked
    ? <LockOutlinedIcon data-access-tier-lock="true" />
    : resolvedTier === ACCESS_TIERS.RESEARCH
      ? <AutoAwesomeOutlinedIcon />
      : undefined;

  const badge = (
    <Chip
        data-access-tier={resolvedTier}
        aria-label={`${label} tier${locked ? ' — locked' : ''}`}
        icon={icon}
        label={label}
        size="small"
        variant="outlined"
        sx={(theme) => {
          const researchColor = theme.palette.mode === 'dark' ? '#b7adff' : '#6554c0';
          const tierColor = resolvedTier === ACCESS_TIERS.RESEARCH
            ? researchColor
            : theme.palette.primary.main;

          return {
            height: compact ? 16 : 20,
            color: tierColor,
            borderColor: alpha(tierColor, theme.palette.mode === 'dark' ? 0.55 : 0.42),
            backgroundColor: alpha(tierColor, theme.palette.mode === 'dark' ? 0.14 : 0.08),
            fontSize: compact ? 8 : 9,
            fontWeight: 800,
            letterSpacing: '0.035em',
            flexShrink: 0,
            '& .MuiChip-label': { px: compact ? 0.55 : 0.7 },
            '& .MuiChip-icon': {
              ml: compact ? 0.4 : 0.55,
              mr: compact ? -0.25 : -0.15,
              color: 'inherit',
              fontSize: compact ? 9 : 11,
            },
            ...sx,
          };
        }}
    />
  );

  return disableTooltip ? badge : <Tooltip title={tooltip} arrow>{badge}</Tooltip>;
}

export default AccessTierBadge;
